// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maturity-page {
  width: 100%;
  padding-bottom: 40px;
  font-family: Lato, sans-serif;
  color: #0b1e2d;
}

.maturity-kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.maturity-kpi {
  background: #fff;
  border: 1px solid #dfe7e8;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.05),
    0 10px 28px -20px rgba(6, 21, 36, 0.35);
  padding: 16px 18px;
}

.maturity-kpi-label {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #5f7484;
}

.maturity-kpi-value {
  margin-top: 6px;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0b1e2d;
  font-variant-numeric: tabular-nums;
}

.maturity-kpi-value span {
  font-size: 20px;
  font-weight: 500;
  color: #8a9ba7;
}

.maturity-kpi-desc {
  margin-top: 6px;
  font-size: 17px;
  line-height: 1.45;
  color: #5f7484;
}

.maturity-card {
  background: #fff;
  border: 1px solid #dfe7e8;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.05),
    0 10px 28px -20px rgba(6, 21, 36, 0.35);
  overflow: hidden;
}

.maturity-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid #eaf0f0;
  flex-wrap: wrap;
}

.maturity-toolbar--soft {
  background: #f7fafa;
}

.maturity-toolbar-label {
  font-size: 16px;
  color: #5f7484;
  margin-right: 2px;
}

.maturity-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 40px;
  padding: 0 14px;
  border-radius: 99px;
  border: 1px solid #dfe7e8;
  background: #fff;
  color: #5f7484;
  font-size: 17px;
  font-weight: 500;
  font-family: Lato, sans-serif;
  cursor: pointer;
  white-space: nowrap;
}

.maturity-chip.on {
  border-color: transparent;
  background: #e1f4f0;
  color: #076b5c;
  font-weight: 600;
}

.maturity-chip-code {
  font-size: 14px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  opacity: 0.85;
}

.maturity-search {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 12px;
  background: #fff;
  border: 1px solid #dfe7e8;
  border-radius: 8px;
  min-width: 220px;
  flex: 1 1;
  max-width: 360px;
}

.maturity-search input {
  border: none;
  background: none;
  outline: none;
  width: 100%;
  font-size: 17px;
  font-family: Lato, sans-serif;
  color: #0b1e2d;
}

.maturity-count {
  margin-left: auto;
  font-size: 17px;
  color: #5f7484;
  white-space: nowrap;
}

.mlist {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 6px 0;
  box-sizing: border-box;
}

.mrow {
  display: flex !important;
  align-items: center;
  gap: 16px;
  padding: 13px 18px;
  border-bottom: 1px solid #eaf0f0;
  transition: background 0.13s;
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  align-self: stretch;
  text-align: left;
  background: none;
  border-left: none;
  border-right: none;
  border-top: none;
  cursor: pointer;
  font-family: Lato, sans-serif;
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
}

.mrow:last-child {
  border-bottom: none;
}

.mrow:hover {
  background: #f7fafa;
}

.mrow.off .mname {
  color: #8a9ba7;
}

.mrow.is-open {
  background: #f7fafa;
}

.mrow-main {
  display: flex;
  align-items: center;
  gap: 11px;
  flex: 1 1 auto;
  min-width: 0;
}

.mcode {
  font-size: 14px;
  color: #076b5c;
  background: #e1f4f0;
  padding: 2px 7px;
  border-radius: 5px;
  flex: none;
  font-weight: 700;
}

.mname {
  font-size: 18px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #0b1e2d;
}

.mrow-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
  margin-left: auto;
}

.mlevel {
  font-size: 16px;
  color: #5f7484;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.maturity-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 99px;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
}

.maturity-pill .dot {
  width: 6px;
  height: 6px;
  border-radius: 99px;
  background: currentColor;
}

.maturity-pill.in {
  background: #e1f4f0;
  color: #076b5c;
}

.maturity-pill.out {
  background: #eaf0f0;
  color: #5f7484;
}

.maturity-switch {
  width: 40px;
  height: 22px;
  border-radius: 99px;
  background: #cdd8d6;
  position: relative;
  flex: 0 0 auto;
  transition: background 0.18s;
  border: none;
  padding: 0;
  cursor: pointer;
}

.maturity-switch.on {
  background: #0d9b87;
}

.maturity-switch span {
  position: absolute;
  top: 2.5px;
  left: 2.5px;
  width: 17px;
  height: 17px;
  border-radius: 99px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  transition: left 0.18s;
}

.maturity-switch.on span {
  left: 20.5px;
}

.maturity-kpi-value--sm {
  font-size: 22px;
  line-height: 1.3;
  word-break: break-word;
}

.maturity-link-btn {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  text-align: left;
  cursor: pointer;
  max-width: 100%;
}

.maturity-source-cell {
  font-size: 16px;
  color: #5f7484;
  font-variant-numeric: tabular-nums;
}

.maturity-num {
  display: inline-flex;
  min-width: 28px;
  justify-content: center;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  color: #0b1e2d;
}

.maturity-num.is-missing {
  color: #8a9ba7;
  font-weight: 500;
}

.mrow-panel {
  padding: 0;
  border-bottom: 1px solid #eaf0f0;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
}

.maturity-grid-wrap {
  width: 100%;
  padding: 0;
  overflow-x: auto;
  box-sizing: border-box;
}

.maturity-grid-wrap .MuiDataGrid-root {
  width: 100% !important;
}

.maturity-grid-wrap .MuiDataGrid-columnHeaderTitle {
  letter-spacing: 0.04em !important;
  overflow: visible !important;
  text-overflow: clip !important;
  white-space: nowrap !important;
}

.maturity-icon-cell {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  opacity: 0.55;
  transition: opacity 0.14s;
}

.maturity-grid-wrap .MuiDataGrid-row:hover .maturity-icon-cell {
  opacity: 1;
}

.maturity-empty {
  padding: 28px 18px;
  text-align: center;
  color: #5f7484;
  font-size: 17px;
}

.maturity-weight-modal {
  width: min(520px, 94vw) !important;
  max-width: 520px !important;
  overflow: hidden !important;
}

.maturity-weight-form {
  display: flex;
  flex-direction: column;
  background: #fff;
}

.maturity-weight-form .incyia-modal-body {
  padding-top: 20px;
  padding-bottom: 8px;
}

.maturity-weight-form .incyia-ffield + .incyia-ffield {
  margin-top: 4px;
}

.maturity-weight-form .incyia-form-inp {
  height: 44px;
  font-size: 17px;
}

.maturity-page .detail-eyebrow {
  font-size: 16px;
}

.maturity-page .detail-title {
  font-size: 34px;
}

.maturity-page .detail-sub {
  font-size: 18px;
}

.maturity-page .detail-head-actions .MuiButton-root {
  font-size: 16px;
  min-height: 44px;
  padding: 8px 18px;
  text-transform: none;
}

.maturity-page .MuiDataGrid-columnHeaderTitle {
  font-size: 15px !important;
}

.maturity-page .MuiDataGrid-cell,
.maturity-page .incyia-desc,
.maturity-page .incyia-desc--primary,
.maturity-page .incyia-name-link {
  font-size: 16.5px !important;
}

@media (max-width: 900px) {
  .maturity-kpis {
    grid-template-columns: 1fr;
  }

  .mrow {
    flex-wrap: wrap;
    gap: 10px;
  }

  .mrow-meta {
    margin-left: 0;
    order: 3;
    width: 100%;
    justify-content: flex-start;
  }

  .maturity-switch {
    margin-left: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/MaturiteMang/MaturiteList.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;2CACyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;2CACyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;EAC5B,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,uBAAuB;EACvB,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,QAAQ;IACR,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".maturity-page {\n  width: 100%;\n  padding-bottom: 40px;\n  font-family: Lato, sans-serif;\n  color: #0b1e2d;\n}\n\n.maturity-kpis {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.maturity-kpi {\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  border-radius: 10px;\n  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.05),\n    0 10px 28px -20px rgba(6, 21, 36, 0.35);\n  padding: 16px 18px;\n}\n\n.maturity-kpi-label {\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #5f7484;\n}\n\n.maturity-kpi-value {\n  margin-top: 6px;\n  font-size: 36px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0b1e2d;\n  font-variant-numeric: tabular-nums;\n}\n\n.maturity-kpi-value span {\n  font-size: 20px;\n  font-weight: 500;\n  color: #8a9ba7;\n}\n\n.maturity-kpi-desc {\n  margin-top: 6px;\n  font-size: 17px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.maturity-card {\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  border-radius: 10px;\n  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.05),\n    0 10px 28px -20px rgba(6, 21, 36, 0.35);\n  overflow: hidden;\n}\n\n.maturity-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #eaf0f0;\n  flex-wrap: wrap;\n}\n\n.maturity-toolbar--soft {\n  background: #f7fafa;\n}\n\n.maturity-toolbar-label {\n  font-size: 16px;\n  color: #5f7484;\n  margin-right: 2px;\n}\n\n.maturity-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 40px;\n  padding: 0 14px;\n  border-radius: 99px;\n  border: 1px solid #dfe7e8;\n  background: #fff;\n  color: #5f7484;\n  font-size: 17px;\n  font-weight: 500;\n  font-family: Lato, sans-serif;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.maturity-chip.on {\n  border-color: transparent;\n  background: #e1f4f0;\n  color: #076b5c;\n  font-weight: 600;\n}\n\n.maturity-chip-code {\n  font-size: 14px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  opacity: 0.85;\n}\n\n.maturity-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 44px;\n  padding: 0 12px;\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  border-radius: 8px;\n  min-width: 220px;\n  flex: 1;\n  max-width: 360px;\n}\n\n.maturity-search input {\n  border: none;\n  background: none;\n  outline: none;\n  width: 100%;\n  font-size: 17px;\n  font-family: Lato, sans-serif;\n  color: #0b1e2d;\n}\n\n.maturity-count {\n  margin-left: auto;\n  font-size: 17px;\n  color: #5f7484;\n  white-space: nowrap;\n}\n\n.mlist {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 6px 0;\n  box-sizing: border-box;\n}\n\n.mrow {\n  display: flex !important;\n  align-items: center;\n  gap: 16px;\n  padding: 13px 18px;\n  border-bottom: 1px solid #eaf0f0;\n  transition: background 0.13s;\n  width: 100% !important;\n  max-width: 100%;\n  min-width: 0;\n  align-self: stretch;\n  text-align: left;\n  background: none;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n  cursor: pointer;\n  font-family: Lato, sans-serif;\n  box-sizing: border-box;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\n.mrow:last-child {\n  border-bottom: none;\n}\n\n.mrow:hover {\n  background: #f7fafa;\n}\n\n.mrow.off .mname {\n  color: #8a9ba7;\n}\n\n.mrow.is-open {\n  background: #f7fafa;\n}\n\n.mrow-main {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.mcode {\n  font-size: 14px;\n  color: #076b5c;\n  background: #e1f4f0;\n  padding: 2px 7px;\n  border-radius: 5px;\n  flex: none;\n  font-weight: 700;\n}\n\n.mname {\n  font-size: 18px;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #0b1e2d;\n}\n\n.mrow-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 0 0 auto;\n  margin-left: auto;\n}\n\n.mlevel {\n  font-size: 16px;\n  color: #5f7484;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.maturity-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 99px;\n  font-size: 15px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.maturity-pill .dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 99px;\n  background: currentColor;\n}\n\n.maturity-pill.in {\n  background: #e1f4f0;\n  color: #076b5c;\n}\n\n.maturity-pill.out {\n  background: #eaf0f0;\n  color: #5f7484;\n}\n\n.maturity-switch {\n  width: 40px;\n  height: 22px;\n  border-radius: 99px;\n  background: #cdd8d6;\n  position: relative;\n  flex: 0 0 auto;\n  transition: background 0.18s;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.maturity-switch.on {\n  background: #0d9b87;\n}\n\n.maturity-switch span {\n  position: absolute;\n  top: 2.5px;\n  left: 2.5px;\n  width: 17px;\n  height: 17px;\n  border-radius: 99px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  transition: left 0.18s;\n}\n\n.maturity-switch.on span {\n  left: 20.5px;\n}\n\n.maturity-kpi-value--sm {\n  font-size: 22px;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.maturity-link-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n  cursor: pointer;\n  max-width: 100%;\n}\n\n.maturity-source-cell {\n  font-size: 16px;\n  color: #5f7484;\n  font-variant-numeric: tabular-nums;\n}\n\n.maturity-num {\n  display: inline-flex;\n  min-width: 28px;\n  justify-content: center;\n  font-variant-numeric: tabular-nums;\n  font-weight: 600;\n  color: #0b1e2d;\n}\n\n.maturity-num.is-missing {\n  color: #8a9ba7;\n  font-weight: 500;\n}\n\n.mrow-panel {\n  padding: 0;\n  border-bottom: 1px solid #eaf0f0;\n  background: #fff;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.maturity-grid-wrap {\n  width: 100%;\n  padding: 0;\n  overflow-x: auto;\n  box-sizing: border-box;\n}\n\n.maturity-grid-wrap .MuiDataGrid-root {\n  width: 100% !important;\n}\n\n.maturity-grid-wrap .MuiDataGrid-columnHeaderTitle {\n  letter-spacing: 0.04em !important;\n  overflow: visible !important;\n  text-overflow: clip !important;\n  white-space: nowrap !important;\n}\n\n.maturity-icon-cell {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.55;\n  transition: opacity 0.14s;\n}\n\n.maturity-grid-wrap .MuiDataGrid-row:hover .maturity-icon-cell {\n  opacity: 1;\n}\n\n.maturity-empty {\n  padding: 28px 18px;\n  text-align: center;\n  color: #5f7484;\n  font-size: 17px;\n}\n\n.maturity-weight-modal {\n  width: min(520px, 94vw) !important;\n  max-width: 520px !important;\n  overflow: hidden !important;\n}\n\n.maturity-weight-form {\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n}\n\n.maturity-weight-form .incyia-modal-body {\n  padding-top: 20px;\n  padding-bottom: 8px;\n}\n\n.maturity-weight-form .incyia-ffield + .incyia-ffield {\n  margin-top: 4px;\n}\n\n.maturity-weight-form .incyia-form-inp {\n  height: 44px;\n  font-size: 17px;\n}\n\n.maturity-page .detail-eyebrow {\n  font-size: 16px;\n}\n\n.maturity-page .detail-title {\n  font-size: 34px;\n}\n\n.maturity-page .detail-sub {\n  font-size: 18px;\n}\n\n.maturity-page .detail-head-actions .MuiButton-root {\n  font-size: 16px;\n  min-height: 44px;\n  padding: 8px 18px;\n  text-transform: none;\n}\n\n.maturity-page .MuiDataGrid-columnHeaderTitle {\n  font-size: 15px !important;\n}\n\n.maturity-page .MuiDataGrid-cell,\n.maturity-page .incyia-desc,\n.maturity-page .incyia-desc--primary,\n.maturity-page .incyia-name-link {\n  font-size: 16.5px !important;\n}\n\n@media (max-width: 900px) {\n  .maturity-kpis {\n    grid-template-columns: 1fr;\n  }\n\n  .mrow {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n\n  .mrow-meta {\n    margin-left: 0;\n    order: 3;\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .maturity-switch {\n    margin-left: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
